export let RequestStateEnum = /*#__PURE__*/function (RequestStateEnum) {
  RequestStateEnum["pending"] = "pending";
  RequestStateEnum["fulfilled"] = "fulfilled";
  RequestStateEnum["rejected"] = "rejected";
  return RequestStateEnum;
}({});